import React, { useEffect, useState } from "react";
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import Stack from '@mui/material/Stack';
import dayjs, { Dayjs } from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import TextField from '@mui/material/TextField';
function OptionCDisable({ onInputChange, catid, namemain, mainid, defaultValuemain, ref, edit }) {

    const today = new Date();
    const Datemax = today.getMonth() === 0 ? today.getFullYear() - 1 + '-' + 12 : today.getFullYear() + '-' + today.getMonth()
    const [value, setValue] = useState(sessionStorage.getItem("CurrentMonth") === null || sessionStorage.getItem("CurrentYear") === null ? dayjs(`${Datemax}-01`) : dayjs(`${sessionStorage.getItem("CurrentYear")}-${sessionStorage.getItem("CurrentMonth")}-01`));



    return (
        <>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Stack spacing={3}>
                    <MobileDatePicker

                        disabled
                        label="Select Month and Year"
                        openTo="year"
                        views={['year', 'month']}
                        value={value}
                        onChange={(newValue) => {
                            onInputChange(newValue.$M + 1, newValue.$y)
                            setValue(newValue);
                            sessionStorage.setItem("CurrentMonth", newValue.$M + 1)
                            sessionStorage.setItem("CurrentYear", newValue.$y)
                        }}
                        minDate={dayjs('2022-10-01')}
                        maxDate={dayjs(Datemax)}
                        renderInput={(params) => <TextField sx={{ width: 200 }} onKeyDown={(evt) => evt.preventDefault()}  {...params} />}
                    />
                </Stack>
            </LocalizationProvider>
      
        </>
    );
};

export default OptionCDisable;
